<template>
  <div
    class="invoice__payment-method"
    v-if="instructions"
    v-html="instructions.value.instructions"
  ></div>
</template>

<script>
export default {
  props: {
    instructions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice__payment-method {
  /deep/ p,
  /deep/ strong,
  /deep/ li {
    color: #4c4c4c;
    font-family: "Arial";
  }
}
</style>
